const canonicalSearch = search => {
  const raw = search?.startsWith('?') ? search.slice(1) : search || '';
  const params = new URLSearchParams(raw);
  return [...params.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};

// React Router 7 applies navigate() inside startTransition, so local grid state
// can commit before location.search. The history action stays POP after load
// and after Back, so a new history entry is a changed location key.
export const shouldIgnoreStaleUrlSync = ({
  locationSearch,
  pendingSearch,
  locationKey,
  pendingLocationKey,
}) => {
  if (pendingSearch == null) return false;
  if (canonicalSearch(locationSearch) === canonicalSearch(pendingSearch)) return false;
  return pendingLocationKey != null && locationKey === pendingLocationKey;
};
